import React, { Fragment, useContext } from "react";
import { openLayerFn } from "./Layout";

import { AppContext } from "../components/AppProvider";

// Utils
import { _O } from "../modules/utils";

import { SlideBanner } from "./Root";

const interfaceDateFormat = "yyyyMMdd";

const LayerOpen = () => {
  openLayerFn($(".myhealth-manage-layer"));
};

export default props => {
  const {
    hospitals,
    reservations,
    setHpLat,
    setHpLon,
    setSelectHpNm,
    setLocationInfo,
  } = props;
  const { mypagecfg, userinfo } = useContext(AppContext);

  return (
    <div className="mymanaged-sections">
      <div className="m-section my-hospital-list">
        <div className="main-section-title">
          활용하기
          <div className="subtxt_btn">전체보기</div>
          <a className="btn-myset btn1"></a>
        </div>

        <div className="treat-list">
          <ul>
            <li>동영상</li>
          </ul>
        </div>
      </div>

      {/* <!-- 카드3_사용자님의 Health Check! --> */}
      <div className="m-section my-blood-pressure">
        <div className="main-section-title">
          {/* <!-- 로그인 전 -->
                    <!-- 
                        당신의 건강관리에 <br/>
                        의연이 함께 하겠습니다.
                    -->
                    
                    <!-- 로그인 후 --> */}
          {userinfo && userinfo.userName != "" ? userinfo.userName : "당신"}의
          Health Check!
          <div className="subtxt_btn">건강관리설정</div>
          <a className="btn-myset  btn2"></a>
        </div>

        {/* <!-- 배너 3개 --> */}
        <div>
          <div className="card03_selfmanage">
            <ul>
              <li className="selfmanage01box">
                <a>
                  <div className="inarea">
                    <div className="intitle">혈압</div>
                    <div className="incont">입력하기</div>
                    <div></div>
                  </div>
                </a>
              </li>
              <li className="selfmanage02box">
                <a>
                  <div className="inarea">
                    <div className="intitle">혈당</div>
                    <div className="incont">입력하기</div>
                    <div></div>
                  </div>
                </a>
              </li>
              <li className="selfmanage03box">
                <a>
                  <div className="inarea">
                    <div className="intitle">체중</div>
                    <div className="incont">입력하기</div>
                    <div></div>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export const MyManagedSections = props => {
  const { mypagecfg, auth } = useContext(AppContext);

  return (
    <div className="mymanaged-sections">
      <div
        className="m-section my-blood-pressure"
        style={{ padding: "11px 20px" }}>
        {/* 로그인 상태  */}
        <LoginStatus status={true} />
        {/* 로그인 상태  */}

        {/* 커스텀 배너 */}
        <div>
          <div className="card03_selfmanage">
            <ul>
              <SelfManagementBox
                style={"selfmanage01box"}
                intitle={"혈압"}
                incont={"입력하기"}
                moveUrl={auth ? "/sm/bp/input" : "/membership/login"}
              />
              <SelfManagementBox
                style={"selfmanage02box"}
                intitle={"혈당"}
                incont={"입력하기"}
                moveUrl={auth ? "/sm/bs/input" : "/membership/login"}
              />
              <SelfManagementBox
                style={"selfmanage04box"}
                intitle={"알레르기"}
                incont={""}
                moveUrl={auth ? "/sm/allergy" : "/membership/login"}
              />
            </ul>
          </div>
        </div>
        {/* 커스텀 배너 */}
      </div>

      <div
        className="m-section my-hospital-list"
        style={{ padding: "0px 20px 11px 20px" }}>
        {/* 동영상 */}
        <div className="main-section-title">
          {/* 활용하기 */}
          {/* <div className="subtxt_btn">전체보기</div><a className="btn-myset btn1"></a> */}
        </div>

        {/* <div className="treat-list">
                    <ul>
                        <li>동영상</li>
                    </ul>
                </div> */}
        <SlideBanner />
      </div>
      {/* 동영상 */}
    </div>
  );
};

export const LoginStatus = props => {
  const { status } = props;
  const { userinfo } = useContext(AppContext);

  return (
    <div className="main-section-title" style={{ paddingBottom: "5px" }}>
      {
        userinfo && userinfo.userName != ""
          ? userinfo.userName + "의 Health Check!"
          : "당신의 Health Check!"
        // :   "당신의 건강관리에 <br/> 의연이 함께 하겠습니다."
      }
      {/* <SubTextBtn 
                text={"건강관리설정"}
                style={"btn-myset  btn2"}
            /> */}
    </div>
  );
};

export const SubTextBtn = props => {
  const { text, style } = props;
  return (
    <Fragment>
      <div className="subtxt_btn">{text}</div>
      <a className={style}></a>
    </Fragment>
  );
};

export const SelfManagementBox = props => {
  const { style, intitle, incont, moveUrl } = props;

  // moveUrl= "/membership/login"
  return (
    <li className={style} onClick={() => _O.OpenMenu(moveUrl)}>
      <a>
        <div className="inarea">
          <div className="intitle">{intitle}</div>
          <div className="incont">{incont}</div>
          <div></div>
        </div>
      </a>
    </li>
  );
};

export const ManagedList = props => {
  return (
    <div className="mymanaged-list">
      <div className="inguide-bar">
        <i /> MY 건강관리 목록을 설정하세요!
      </div>
      <a href={void 0} className="btn-myset btn"></a>
    </div>
  );
};
